import React from "react";

const FilterIcon = ({ className }) => (
  <svg
    className={className}
    width="1.5vw"
    viewBox="0 0 27 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    style={{ height: "auto" }}
  >
    <path
      d="M25.946 4.125H23.2794M25.946 12H19.2794M25.946 19.875H19.2794M7.27938 22.5V14.0491C7.27938 13.7761 7.27938 13.6396 7.25215 13.509C7.228 13.3932 7.18806 13.2811 7.13341 13.1757C7.07179 13.0571 6.98517 12.9505 6.8119 12.7372L2.41352 7.32522C2.24026 7.11203 2.15363 7.00543 2.09202 6.88672C2.03736 6.78141 1.99742 6.66931 1.97327 6.55347C1.94605 6.4229 1.94604 6.28639 1.94604 6.01336V3.6C1.94604 2.86493 1.94604 2.4974 2.09136 2.21664C2.2192 1.96968 2.42318 1.76889 2.67406 1.64305C2.95927 1.5 3.33264 1.5 4.07938 1.5H15.8127C16.5595 1.5 16.9328 1.5 17.218 1.64305C17.469 1.76889 17.6728 1.96968 17.8007 2.21664C17.946 2.4974 17.946 2.86493 17.946 3.6V6.01336C17.946 6.28639 17.9188 6.4229 17.8947 6.55347C17.8947 6.66931 17.8547 6.78141 17.8 6.88672C17.7384 7.00543 17.6518 7.11203 17.4786 7.32522L13.0802 12.7372C12.907 12.9505 12.8203 13.0571 12.7587 13.1757C12.704 13.2811 12.664 13.3932 12.6399 13.509C12.6127 13.6396 12.6127 13.7761 12.6127 14.0491V18.5625L7.27938 22.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FilterIcon;
